import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { isUTMSearchParam } from './useCleanUtmParams.utils'

export function useCleanUtmParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const cleanedParams = new URLSearchParams(searchParams)

    for (const key of cleanedParams.keys()) {
      if (isUTMSearchParam(key)) {
        cleanedParams.delete(key)
      }
    }

    if (cleanedParams.toString() !== searchParams.toString()) {
      setSearchParams(cleanedParams, { replace: true })
    }
  }, [searchParams, setSearchParams])
}
